module.exports = __webpack_public_path__ + "img/social_group_inactive.92a8a3c7.svg";